import { FC } from 'react';

import { ReportType } from 'app/services/edpApiV1/reports';
import FormRecord from '../form-record';

const ReportConsultations: FC = () => <FormRecord type={ReportType.Consultation} />;

export default ReportConsultations;
